import { useContext, useState } from 'react';
import RestrictedToPortfolioMode from '@/components/RestrictedToPortfolioMode';
import PortfolioMode from '@/lib/constants/PortfolioMode.enum';
import useCreateChallenge from './useCreateChallenge';
import PhaseContext from '../../../PhaseContext';
import FormattedMessageWithChallengeNaming from '@/components/FormattedMessageWithChallengeNaming';
import RowContext from '@/components/ChallengePortfolio/NormalView/Rows/Row/RowContext';
import CreateButton from './CreateButton';
import Prompt from '@/components/Prompt';
import Dialog from '@/components/Dialog';
import { FormattedMessage } from 'react-intl';
import ModelSelect from './ModelSelect';
import ModelType from '@/lib/constants/challengeModel/ModelType.enum';
import useDefaultModel from '../../../portfolio-item/PortfolioItemFields/usePortfolioItemModel/useDefaultModel';

const CreateChallenge = () => {
  const row = useContext(RowContext);
  const phase = useContext(PhaseContext);

  const [createPromptOpen, setCreatePromptOpen] = useState(false);

  const defaultModel = useDefaultModel(ModelType.CHALLENGE);
  const [selectedModelId, setSelectedModelId] = useState<number | null>(
    defaultModel?.id ?? null,
  );

  const createChallenge = useCreateChallenge();

  return (
    <RestrictedToPortfolioMode mode={PortfolioMode.STUDENT}>
      <CreateButton
        tooltip={
          <FormattedMessageWithChallengeNaming id="portfolio.create_challenge.tooltip" />
        }
        onClick={() => setCreatePromptOpen(true)}
      />
      <Prompt
        open={createPromptOpen}
        onOk={name => {
          setCreatePromptOpen(false);

          createChallenge(name, phase, row.id, selectedModelId);

          // Wait for the dialog animation to finish before resetting state.
          // This prevents the input reset from happening visibly.
          setTimeout((): void => {
            setSelectedModelId(defaultModel?.id ?? null);
          }, 250);
        }}
        OkButton={Dialog.Actions.CreateButton}
        onCancel={() => setCreatePromptOpen(false)}
        emptyError="prompt.errors.name_empty"
      >
        <Dialog.Title>
          <FormattedMessageWithChallengeNaming id="portfolio.create_challenge.title" />
        </Dialog.Title>
        <Prompt.TextField
          label={
            <FormattedMessage id="portfolio.create_challenge.input_label" />
          }
        />
        <ModelSelect
          variant={ModelType.CHALLENGE}
          selectedModelId={selectedModelId}
          setSelectedModelId={modelId => setSelectedModelId(modelId)}
        />
      </Prompt>
    </RestrictedToPortfolioMode>
  );
};

export default CreateChallenge;
